module.exports = __webpack_public_path__ + "img/ls3.e8c98c64.png";